
export const HealthServiceEnum = {
	SANTECLAIR: "SANTECLAIR",
	ITELIS: "ITELIS",
	CARTEBLANCHE: "CARTEBLANCHE",
	KALIXIA: "KALIXIA",
	KALIVIA: "KALIVIA",
	NONE: "NONE"
}

export const MemberTypeEnum = {
	MEMBER_TYPE_AFFILIATE: 2,
	MEMBER_TYPE_CLIENT: 1
}

export default {
	HealthServiceEnum,
	MemberTypeEnum
};
